import type { InvestmentBoardDto } from '@/api/pipelines/types';

import { type PipelineBoard, PipelineRouteKey } from '../../common/types';
import {
  createBooleanPipelineFilter,
  createStaticPipelineFilter,
  mapPipelineOptions,
  mapPipelineTotals,
} from '../../common/utils/mapping';
import { mapInvestmentEntryToPipelineCard } from './map-card';

export const mapInvestmentBoardToPipelineBoard = (board: InvestmentBoardDto): PipelineBoard => ({
  pipeline: PipelineRouteKey.Investment,
  columns: board.columns.map((column) => ({
    stage: column.stage,
    label: column.label,
    order: column.order,
    terminal: column.terminal,
    count: column.count,
    cards: column.entries.map(mapInvestmentEntryToPipelineCard),
  })),
  filterDefinitions: [
    createStaticPipelineFilter(
      'introducerUserIds',
      'introducers',
      'Introducer',
      mapPipelineOptions(board.filterOptions.introducers),
    ),
    createStaticPipelineFilter(
      'investorUserIds',
      'investors',
      'Investor',
      mapPipelineOptions(board.filterOptions.investors),
    ),
    createStaticPipelineFilter(
      'fundIds',
      'funds',
      'Fund',
      mapPipelineOptions(board.filterOptions.funds),
    ),
    createStaticPipelineFilter(
      'introductionTypes',
      'types',
      'Type',
      mapPipelineOptions(board.filterOptions.introductionTypes),
    ),
    createStaticPipelineFilter(
      'timerStatuses',
      'timers',
      'Timer',
      mapPipelineOptions(board.filterOptions.timerStatuses),
    ),
    createStaticPipelineFilter(
      'stages',
      'stages',
      'Stage',
      board.filterOptions.stages.map((stage) => ({
        value: stage.value,
        label: stage.label,
        terminal: stage.terminal,
      })),
    ),
    createBooleanPipelineFilter('activeOnly', 'activeOnly', 'Active only'),
  ],
  totals: mapPipelineTotals(board.totals),
});
